var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicY1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8V7.5M3 7.5V20.5H18C18 20.5 18 14.5 18 12.5M3 7.5V7V6.5H12",
    stroke: "#0078BB",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3V10",
    stroke: "#0078BB",
    strokeWidth: 1.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.5H21.5",
    stroke: "#0078BB",
    strokeWidth: 1.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3876 14.3868L7.9248 10.2884H9.5792L11.149 12.9392L12.7094 10.2884H14.3544L11.8634 14.4244V17H10.3876V14.3868Z",
    fill: "#0078BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicY1);
export default __webpack_public_path__ + "static/media/Clinic-Y1.69543039d9e45d674cfd9ee34da9bd3a.svg";
export { ForwardRef as ReactComponent };